<template>
  <div class="c-modal-message" :class="{'close-modal': hide}">
    <div class="message">
      <div class="message-container">
        <div class="text">
          <h3>{{ modalContent[modalType].title }}</h3>
          <p>{{ modalContent[modalType].description }}</p>
        </div>
        <div v-show="needComment" class="comment-place">
          <div>Результат: {{ percent }}%</div>
        </div>
        <div v-show="needComment" class="comment-place">
          <div>Комментарий</div>
          <textarea v-model="comment" class="comment-input" title="Комментарий"></textarea>
        </div>
        <div v-if="needComment" class="buttons">
          <n-button :disabled="!comment.length > 0" flat class="modal-button agree" @click="agree(modalType)">Да</n-button>
          <n-button flat class="modal-button cancel" @click="close">Нет</n-button>
        </div>
        <div v-else class="buttons">
          <n-button flat class="modal-button agree" @click="agree(modalType)">Да</n-button>
          <n-button flat class="modal-button cancel" @click="close">Нет</n-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CModalMessage',
  props: {
    hide: {
      type: Boolean,
      required: true,
    },
    percent: {
      type: Number,
      default: 0,
    },
    state: {
      type: String,
      required: true,
    },
    modalType: {
      type: String,
      required: true,
    },
    needComment: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      comment: '',
      modalContent: {
        interrupt: {
          title: 'Прервать аттестацию?',
          description: 'При прерывании сеанса, данный КЛН сохранится в разделе прерванные. Продолжить его можно лишь в день начала.',
        },
        cancel: {
          title: 'Отменить аттестацию?',
          description: 'При отмене аттестации она не будет сохранена, и восстановить ее будет невозможно.',
        },
        deleteQuestion: {
          title: 'Удалить пункт с вопросом?',
          description: 'Удаленый вопрос не идёт в расчет результата, восстановить его можно только в течении аттестации.',
        },
        restoreQuestion: {
          title: 'Восстановить вопрос?',
          description: 'Восстановленный вопрос будет учитываться при подчете результатов',
        },
        finish: {
          title: 'Завершить аттестацию?',
          description: 'Редактировать результат невозможно. Данная аттестация появится в вкладке "Не согласованные".',
        },
        accept: {
          title: 'Согласовать результат?',
          description: 'Соглашаясь с результатом вы даете разрешение на отправку данных в систему.',
        },
        decline: {
          title: 'Не согласовывать результат?',
          description: 'Не согласовывая результат, вы не получите очков за него',
        },
        logout: {
          title: 'Сменить пользователя?',
          description: '',
        },
      },
    }
  },
  methods: {
    agree(modalType) {
      this.$emit('update:state', modalType)
      this.$emit('update:comment', this.comment)
      this.close()
    },
    close() {
      this.$emit('update:hide', true)
    },
  },
}
</script>

<style scoped lang="scss">
.c-modal-message {
  position: absolute;
  display: flex;
  z-index: 10;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .2);
  align-items: center;
  justify-content: center;

  .comment-input {
    width: 300px;
    height: 200px;
    border: 1px solid var(--secondary) !important;
    input:-webkit-autofill {
      color: #ffffff !important;
    }
    resize: none;
    &:focus {
      outline: none;
    }
  }
  .message {
    position: absolute;
    display: flex;
    background-color: #ffffff;
    border-radius: 16px;
    width: 335px;
    .message-container {
      margin: 16px;
      .text {
        h3 {
          margin: 0 0 4px 0;
          padding: 0;
          font-size: 1.20em;
          color: var(--secondary);
          font-weight: bold;
        }
        p {
          min-height: 24px;
          margin: 0 0 12px 0;
          padding: 0;
          font-size: 1.05em;
          color: #6D6F7B;
        }
      }
      .buttons {
        display: flex;
        justify-content: space-between;
        .modal-button {
          width: 145px;
          height: 45px;
          background-color: #F2F3F7;
          border-radius: 8px;
          font-weight: bold;
          font-size: 1.05em;
          &.agree {
            color: #DB0007;
            margin-right: 12px;
          }
          &.cancel {
            color: var(--secondary)
          }
        }
      }
    }
  }
}
.close-modal {
  display: none;
}
</style>
